"use strict";
/**
 * @file Created on Wed Jun 24 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");
/**
 * @enum SimulationValidatorType
 */


var SimulationValidatorType;

(function (SimulationValidatorType) {
  SimulationValidatorType["FULL"] = "FULL_VALIDATION";
  SimulationValidatorType["ACCEPTABLE"] = "ACCEPTABLE_VALIDATION";
})(SimulationValidatorType = exports.SimulationValidatorType || (exports.SimulationValidatorType = {}));
/**
 * @author Tomas Leity
 */


var SimulationValidator =
/*#__PURE__*/
function () {
  function SimulationValidator(type, simulation, values) {
    _classCallCheck(this, SimulationValidator);

    this.type = type;
    this.simulation = simulation;
    this.values = values;
  }
  /**
   * Static helper to get actual simulated values
   *
   * @returns {Map<string, SimulationValue<any>} Map of simulated values
   *
   * @param valuesMap Map of simulated values
   */


  _createClass(SimulationValidator, [{
    key: "getSimulation",
    value: function getSimulation() {
      return this.simulation;
    }
  }, {
    key: "getValues",
    value: function getValues() {
      return this.values;
    }
  }, {
    key: "getSimulatedValues",
    value: function getSimulatedValues() {
      return SimulationValidator.getSimulatedValues(this.getValues());
    }
  }, {
    key: "hasSimulatedValues",
    value: function hasSimulatedValues() {
      return !this.getSimulatedValues().isEmpty();
    }
  }, {
    key: "isRejected",
    value: function isRejected() {
      return SimulationValidator.isRejected(this.getSimulatedValues());
    }
    /**
     * TODO ZSt check this, explicit information about running simulation. Not only derived from simulations objects.
     * TODO ZSt change representation of sim values in this class
     * https://jira.etnetera.cz/browse/LOG-5351
     */

  }, {
    key: "isPending",
    value: function isPending() {
      return SimulationValidator.isPending(this.getSimulatedValues());
    }
  }, {
    key: "isEqual",
    value: function isEqual(otherSimulation) {
      var otherValidator = otherSimulation.validator(this.type);
      var otherValues = otherValidator.getSimulatedValues();
      var thisValues = this.getSimulatedValues();

      if (thisValues.count() !== otherValues.count()) {
        return true;
      }

      var thisObject = thisValues.map(function (sv) {
        return sv.simulatedValue;
      }).toJSON();
      var otherObject = otherValues.map(function (sv) {
        return sv.simulatedValue;
      }).toJSON();
      return JSON.stringify(thisObject) === JSON.stringify(otherObject);
    }
  }, {
    key: "clearAcceptedValues",
    value: function clearAcceptedValues() {
      var simulation = this.simulation;
      var simulatedValues = this.getSimulatedValues();
      simulatedValues.forEach(function (v, name) {
        if (v.isAccepted()) {
          simulation = simulation.copy(name, null);
        }
      });
      return simulation;
    }
  }, {
    key: "acceptSimulatedValue",
    value: function acceptSimulatedValue(field, originalValue, note) {
      var simulatedValues = this.getSimulatedValues();
      var v = simulatedValues.get(field);

      if (!utils_1.Utils.isValueMissing(v)) {
        return this.simulation.copy(field, v.accept(originalValue || v.originalValue, note));
      }

      return this.simulation;
    }
  }, {
    key: "acceptSimulatedValues",
    value: function acceptSimulatedValues(originalValues, note) {
      var simulation = this.simulation;
      var simulatedValues = this.getSimulatedValues();
      simulatedValues.forEach(function (v, name) {
        if (!v.isAccepted()) {
          var originalValue = originalValues.get(name);
          simulation = simulation.copy(name, v.accept(originalValue || v.originalValue, note));
        }
      });
      return simulation;
    }
  }, {
    key: "rejectSimulatedValue",
    value: function rejectSimulatedValue(field, originalValue, note) {
      var simulatedValues = this.getSimulatedValues();
      var v = simulatedValues.get(field);

      if (!utils_1.Utils.isValueMissing(v)) {
        return this.simulation.copy(field, v.reject(originalValue || v.originalValue, note));
      }

      return this.simulation;
    }
  }, {
    key: "rejectSimulatedValues",
    value: function rejectSimulatedValues(originalValues, note) {
      var simulation = this.simulation;
      var simulatedValues = this.getSimulatedValues();
      simulatedValues.forEach(function (v, name) {
        var originalValue = originalValues.get(name);
        simulation = simulation.copy(name, v.reject(originalValue || v.originalValue, note));
      });
      return simulation;
    }
  }], [{
    key: "getSimulatedValues",
    value: function getSimulatedValues(valuesMap) {
      return valuesMap.filter(function (v) {
        return v !== null;
      });
    }
    /**
     * Static helper to check simulated values for rejected values.
     *
     * @returns true if some of the simulated values are rejected
     *
     * @param valuesMap Map of simulated values
     */

  }, {
    key: "isRejected",
    value: function isRejected(valuesMap) {
      return valuesMap.some(function (v) {
        return !v.isAccepted();
      });
    }
    /**
     * Static helper to check simulated values for pending state.
     *
     * @returns true if some of the simulated values are pending
     *
     * @param valuesMap Map of simulated values
     */

  }, {
    key: "isPending",
    value: function isPending(valuesMap) {
      return valuesMap.some(function (v) {
        return v !== null && v.accepted === null;
      });
    }
  }]);

  return SimulationValidator;
}();

exports.SimulationValidator = SimulationValidator;